import { CommonModule } from '@angular/common';
import { Component, inject, input, OnInit, output, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs';
import { DropdownComponent } from 'src/app/components/shared/dropdown/dropdown.component';
import { AddResumeLanguage } from 'src/app/models/resume/add-resume';
import { DropDownKeywords, DropdownOption } from 'src/app/models/shared/dropdown-option';
import { DropdownService } from 'src/app/services/dropdown.service';
import { ResumeService } from 'src/app/services/resume.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-language',
  imports: [CommonModule, ReactiveFormsModule, DropdownComponent],
  templateUrl: './modal-language.component.html',
  styleUrl: './modal-language.component.css'
})
export class ModalLanguageComponent {
  public resumeId = input<number | null>(null);
  public onResumeLanguage = output<AddResumeLanguage>();

  private readonly resumeService = inject(ResumeService);
  private readonly dropdownService = inject(DropdownService);
  private readonly _toastrService = inject(ToastrService);

  public form = new FormGroup({
    id: new FormControl(0),
    resumeId: new FormControl(0),
    languageName: new FormControl<any>(''),
    languageId: new FormControl<any>('', [Validators.required]),
    languageLevelId: new FormControl(null, [Validators.required]),
    url: new FormControl(null),
    isEnabled: new FormControl(true)
  });

  languages: DropdownOption[] = [];
  languagLevels: DropdownOption[] = [];
  isSearching = signal<boolean>(false);
  showDropdown = signal<boolean>(false);

  isLoading = signal<boolean>(false);

  ngOnInit(): void {
    this.getOptions();
  }

  getOptions() {
    this.dropdownService.GetOptions(DropDownKeywords.LanguageLevels,null,undefined,true).subscribe({
      next: res => {
        this.languagLevels = res;
      }
    });
    this.dropdownService.GetOptions(DropDownKeywords.Languages,1,undefined,true).subscribe({
      next: res => {
        this.languages = res;
      }
    });
  }

  selectLanguage(Language: DropdownOption): void {
    this.form.patchValue({
      languageName: Language.text
    }, {
      onlySelf: true,
      emitEvent: false
    })
    this.languages = []
  }

  onFocus(): void {
    if (this.form.get("languageName")?.value && this.languages.length > 0) {
      this.showDropdown.set(true);
    }
  }

  onBlur(): void {
    setTimeout(() => {
      this.showDropdown.set(false);
    }, 200)
  }

  reset() {
    this.form.reset();
    this.form.patchValue({
      isEnabled: true
    }, {
      onlySelf: true,
      emitEvent: false
    });
  }

  closeModal() {
    this.reset();
    let divModal = document.getElementById('modalIdiomas');
    let modal = (window as any).bootstrap.Modal.getInstance(divModal);
    modal.hide();
  }

  submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const resumeLanguage = {
      ...this.form.getRawValue(),
      languageLevel: this.languagLevels?.find(level => level.id == this.form.getRawValue().languageLevelId)?.text,
      languageName: this.languages?.find(language => language.id == this.form.getRawValue().languageId)?.text,
      resumeId: this.resumeId()
    } as any as AddResumeLanguage;

    if (this.resumeId()) {
      this.isLoading.set(true);
      this.resumeService.addResumeLanguage({
        ...resumeLanguage
      }).subscribe({
        next: res => {
          this.isLoading.set(false);
          this.onResumeLanguage.emit(resumeLanguage)
          this.closeModal();
        }, error: res => {
          this.isLoading.set(false);
          Swal.fire({
            title: 'Error',
            text: 'Ocurrió un error al guardar el registro.',
            icon: 'error',
            confirmButtonColor: '#d33'
          });
        }
      })
    } else {
      this.onResumeLanguage.emit(resumeLanguage);
      this.closeModal();
    }
  }
}
